<template>
  <div>
    <v-container fluid class="sign-page-content mt-1 page-container">
      <img :src="logo" width="70px" />
    </v-container>
    <router-view />
  </div>
</template>
<script>
export default {
  name: "MainLayout",
  computed: {
    logo() {
      return require(`@/assets/logo.svg`);
    },
  },
  mounted() {
    document.title = "Yello nabídka";
  },
};
</script>
